import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";

const restaurantName = process.env.REACT_APP_RESTAURANT_NAME;
const colorBackground = process.env.REACT_APP_BACKGROUND_COLOR;
const siteMedSrc = process.env.REACT_APP_MEDIA_SRC;
const businessHoursLine1 = process.env.REACT_APP_BUSINESSHOURS_LINE1;
const businessHoursLine2 = process.env.REACT_APP_BUSINESSHOURS_LINE2;
const businessHoursLine3 = process.env.REACT_APP_BUSINESSHOURS_LINE3;
const businessHoursLine4 = process.env.REACT_APP_BUSINESSHOURS_LINE4;

export default function BusinessCard() {
  return (
    <Card>
      <CardActionArea
        className="color-scheme"
        sx={{ cursor: "default !important", pointerEvents: "none", backgroundColor: colorBackground }}
      >
        <CardMedia
          component="img"
          height="140"
          image={siteMedSrc + "business-hours" + ".png"}
          title={`${restaurantName} Business Hours`}
          alt={`${restaurantName} Business Hours`}
          width="100%"
          loading="lazy"
        />
        <CardContent>
          <Typography gutterBottom variant="h4" component="div">
            Business Hours
          </Typography>
          <Typography gutterBottom variant="h6" component="div">
            <span>{businessHoursLine1}</span>
            <br></br>
            <span>{businessHoursLine2}</span>
            <br></br>
            <span>{businessHoursLine3}</span>
            <br></br>
            <span>{businessHoursLine4}</span>
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
